import React from 'react';
import PropTypes from 'prop-types';

import './FiltersExposedSection.scss';

const FiltersExposedSectionWrapper = ({ title, children }) => {
  return (
    <div className="filters-exposed-section">
      <p className="filters-exposed-section__title">{title}</p>
      <div className={'filters-exposed-section__content'}>{children}</div>
    </div>
  );
};

FiltersExposedSectionWrapper.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
};

export default FiltersExposedSectionWrapper;
